import React from 'react';
import { motion } from 'framer-motion';
import { XIcon, CheckIcon } from 'lucide-react';
export function Solution() {
  return <section className="py-24 bg-cream" data-id="element-96">
      <div className="max-w-7xl mx-auto px-6 lg:px-8" data-id="element-97">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-98">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-99">
            Stop fighting your body.
          </h2>
          <p className="text-teal-muted text-lg" data-id="element-100">
            Traditional advice says "eat less, move more." But when your
            cortisol is high, intense workouts and strict diets actually signal
            your body to store more fat.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-101">
          {/* The Gym Card */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="bg-white p-8 md:p-12 border border-cream-dark" data-id="element-102">
            <h3 className="text-2xl font-serif mb-2 text-teal-muted" data-id="element-103">
              The Gym
            </h3>
            <p className="text-sm font-medium text-teal-muted uppercase tracking-wider mb-8" data-id="element-104">
              Increases Stress
            </p>

            <ul className="space-y-6" data-id="element-105">
              {['High-intensity workouts spike cortisol further', 'Leaves you exhausted for the rest of the day', "Requires 60+ minutes you don't have", 'Often leads to increased cravings and bloating', 'Body holds onto fat as a stress response'].map((item, i) => <li key={i} className="flex items-start" data-id="element-106">
                  <XIcon className="w-5 h-5 text-teal-muted/50 mt-0.5 mr-4 flex-shrink-0" data-id="element-107" />
                  <span className="text-teal-muted" data-id="element-108">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* The Reset Card */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-sage text-white p-8 md:p-12 relative overflow-hidden" data-id="element-109">
            {/* Decorative background element */}
            <div className="absolute -right-12 -top-12 w-48 h-48 bg-white/5 rounded-full blur-2xl" data-id="element-110"></div>

            <div className="relative z-10" data-id="element-111">
              <h3 className="text-2xl font-serif mb-2 text-white" data-id="element-112">
                The Cortisol Reset
              </h3>
              <p className="text-sm font-medium text-cream uppercase tracking-wider mb-8" data-id="element-113">
                Lowers Stress
              </p>

              <ul className="space-y-6" data-id="element-114">
                {['Gentle movements that signal safety to your nervous system', 'Leaves you energized and clear-headed', 'Takes exactly 15 minutes a day', 'Reduces inflammation and flattens the stomach', 'Allows your body to naturally release stubborn weight'].map((item, i) => <li key={i} className="flex items-start" data-id="element-115">
                    <CheckIcon className="w-5 h-5 text-cream mt-0.5 mr-4 flex-shrink-0" data-id="element-116" />
                    <span className="text-cream/90" data-id="element-117">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}